import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SessionService } from '../session.service';

import { of } from "rxjs";


@Injectable()
export class SessionFormResolver implements Resolve<Observable<string>> {

  constructor(private sessionService: SessionService) { }

  resolve(route: ActivatedRouteSnapshot) {
    if (route.paramMap.get('sessionId') !== 'new') {
      return this.sessionService.getSession(Number(route.paramMap.get('sessionId'))).catch(() => {
        return of('error');
      });
    } else {
      return of('new');
    }
  }
}

